module.exports = __webpack_public_path__ + "static/media/phone_3.ca1f5136.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/introduction/assets/phone_3.png
// module id = 212
// module chunks = 0